export default __webpack_public_path__ + "static/media/banan.86781ca9.png";